import React, { PureComponent } from 'react';
import { Fab, Tooltip } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { setSnackbar, resetSnackbar } from '../../actions';
import { isSessionActive } from '../../utility/common/SessionExpiry';

import { withStyles } from "@mui/styles";

const styles = theme => ({
  fab: {
    backgroundColor: '#4c5b5c',
    color: '#fff',
    position: 'fixed',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 2000,
    '&:hover':{
      backgroundColor: '#3a4647'
    }
  },
  extendedIcon: {

  },
});

class ToolsSticky extends PureComponent {
  render() {
    const { classes } = this.props;
    const validToken = (this.props.toolsToken === localStorage.getItem('tools-token'))? true : false;
    const validDate = isSessionActive(this.props.toolsExpiry, this.props.toolsClockOffset);
    const loggedIn = (validToken && validDate);
    if(!loggedIn) return null;
    return (
      <Fab
        variant="extended"
        size="large"
        aria-label="Return"
        className={classes.fab}
        href='/tools/'
      >
        <Tooltip title="Tools">
          <BuildIcon size={'small'} className={classes.extendedIcon} />
        </Tooltip>
      </Fab>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    toolsUsername: state.tools.username,
    toolsToken: state.tools.token,
    toolsExpiry: state.tools.expiry,
    toolsClockOffset: state.tools.clockOffset
  };
};

export default withStyles(styles, { withTheme: true }) (connect(mapStateToProps, {
  setSnackbar,
  resetSnackbar
})(withRouter(ToolsSticky)));
